'use client';

import { usePathname } from 'next/navigation';

export function useAbsolutePathname() {
  const pathname = usePathname();

  return `https://${process.env.NEXT_PUBLIC_DOMAIN}${pathname}`;
}
